<template>
  <div
    v-if="!isEmptyObject(notificacion)"
    class="email-app-details"
  >

    <!-- Notification Header -->
    <div class="email-detail-header">

      <!-- Header: Left -->
      <div class="email-header-left d-flex align-items-center">
        <span class="go-back mr-1">
          <feather-icon
            :icon="$store.state.appConfig.isRTL ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
            size="20"
            class="align-bottom"
            @click="$emit('close-notification-view')"
          />
        </span>
        <h4 class="email-subject mb-0">
          Detalles de notificación
        </h4>
      </div>

      <!-- Header: Right -->
      <div class="email-header-right ml-2 pl-1">
        <!-- Marcar como leído/no leído -->
        <feather-icon
          v-b-tooltip.hover.left="`Marcar notificación como ${notificacion.visto ? 'no' : ''} leída`"
          :icon="`${notificacion.visto ? 'ThumbsDownIcon' : 'ThumbsUpIcon'}`"
          size="17"
          class="cursor-pointer"
          :class="{ 'text-danger': notificacion.visto }"
          @click="markAs(notificationId)"
        />
      </div>
    </div>

    <!-- notification Details -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="email-scroll-area scroll-area"
    >
      <b-row>
        <b-col cols="12">
          <div class="email-label">
            <div
              v-if="notificacion.tabla_destino"
              class="d-inline"
            >
              <small class="text-muted ml-75 mr-25"><b>Dirigido a:</b></small>
              <b-badge variant="light-secondary">
                {{ notificacion.tabla_destino }}
              </b-badge>
            </div>
            <div
              v-if="notificacion.prioridad"
              class="d-inline"
            >
              <small class="text-muted ml-75 mr-25"><b>Prioridad:</b></small>
              <b-badge :variant="`light-${notificationPriority(notificacion.prioridad)}`">
                {{ notificacion.prioridad }}
              </b-badge>
            </div>
          </div>
        </b-col>
      </b-row>

      <!-- Notification content -->
      <b-row>
        <b-col cols="12">
          <notification-message-card :item="notificacion" />
        </b-col>
      </b-row>

      <!-- Notification url -->
      <b-row v-if="notificacion.url && !isEmptyObject(JSON.parse(notificacion.url))">
        <b-col cols="12">
          <b-card>
            <div class="d-flex justify-content-between">
              <h5 class="mb-0">
                Presione para ver
                <b-link
                  v-if="JSON.parse(notificacion.url).tipo === 0"
                  :to="JSON.parse(notificacion.url).link"
                >
                  contenido
                </b-link>
                <b-link
                  v-if="JSON.parse(notificacion.url).tipo === 1"
                  target="_blank"
                  :href="JSON.parse(notificacion.url).link"
                >
                  liga
                </b-link>
              </h5>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BBadge,
  BCard,
  BLink,
  VBTooltip,
} from 'bootstrap-vue'
import store from '@/store'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { computed, watch } from '@vue/composition-api'
import { notificationPriority } from '@core/utils/filter'
import { isEmptyObject } from '@core/utils/utils'
import useNotificacion from './useNotificacion'
import NotificationMessageCard from './NotificationMessageCard.vue'

export default {
  components: {
    // BSV
    BRow,
    BCol,
    BBadge,
    BCard,
    BLink,

    // 3rd Party
    VuePerfectScrollbar,

    // SFC
    NotificationMessageCard,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    notificationId: {
      type: [Number, null],
      default: null,
    },
  },
  setup(props) {
    const { markAs } = useNotificacion()
    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
      wheelPropagation: false,
    }

    // * Notification detail from store
    const notificacion = computed(() => store.getters['notificaciones/notificacionDetail'](props.notificationId))

    watch(() => props.notificationId, id => {
      if (!notificacion.value.visto) markAs(id)
    })

    return {
      // Method
      markAs,

      // UI
      perfectScrollbarSettings,

      // Data
      notificacion,

      // Filter
      notificationPriority,
      isEmptyObject,
    }
  },
}
</script>

<style>

</style>
